import CartBaseItemView from '../../baseViews/ItemView';
import SelectedPromoCodeMessageTemplate from '../templates/SelectedPromoCodeMessageTemplate';

const SelectedPromoCodeMessage = CartBaseItemView.extend({
	JSXTemplate: SelectedPromoCodeMessageTemplate,
	templateHelpers () {

		return {
			displySuccessFullPromoCodeMessage: !this.model.get('promoCodeError') && this.model.get('SelectedPromoCode')
		};

	},
	initialize () {

		this.listenTo(this.model, 'change', this.render, this);

	}
});

export default SelectedPromoCodeMessage;
